import Resizer from "react-image-file-resizer";
export type CompressFormat = "JPEG" | "PNG" | "WEBP";
export const resizeFile = (
  file: File,
  maxWidth = 800,
  maxHeight = 800,
  compressFormat: CompressFormat = "JPEG",
  quality = 50
): Promise<File> =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      compressFormat,
      quality,
      0, 
      (uri) => {
        resolve(uri as File);
      },
      "file"
    );
  });